/* unplugin-vue-components disabled */import { render } from "./riskInfo.vue?vue&type=template&id=d5c1bd0c&scoped=true"
import script from "./riskInfo.vue?vue&type=script&lang=js"
export * from "./riskInfo.vue?vue&type=script&lang=js"

import "./riskInfo.vue?vue&type=style&index=0&id=d5c1bd0c&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.pro/src/fe-pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5c1bd0c"]])

export default __exports__